export default "__VITE_ASSET__ZACp7xls__"